export const ID_ROUTE_PARAM: string = 'id';
export const ID_ROUTE: string = `:${ID_ROUTE_PARAM}`;

export const TOKEN_ROUTE_PARAM: string = 'token';
export const TOKEN_ROUTE: string = `:${TOKEN_ROUTE_PARAM}`;

export const CREATE_ROUTE: string = 'tworzenie';
export const EDIT_ROUTE: string = 'edycja';
export const PREVIEW_ROUTE: string = 'podglad';
